import React, { useMemo } from "react";
import { URLSearchParamsInit } from "react-router-dom";
import { ClientForm } from "~/components/forms/ClientForm";
import Updater from "~/components/forms/Updater";
import { ValueRenderer } from "~/components/forms/ValueContext";
import EnumDropdownFormField from "~/visuals/organisms/EnumDropdownFormField";

export type SortFilterProps<
  TFilter extends { sortBy: string },
  E extends string
> = {
  filters: TFilter | null;
  setFilters: React.Dispatch<TFilter>;
  searchParams: URLSearchParams;
  setSearchParams: (
    nextInit: URLSearchParamsInit,
    navigateOptions?:
      | {
          replace?: boolean | undefined;
          state?: any;
        }
      | undefined
  ) => void;
  options: Record<E, string>;
  required?: boolean;
  defaultSort?: E;
};

export const SearchSortBy = <
  TFilter extends { sortBy: string },
  E extends string
>({
  filters,
  setFilters,
  searchParams,
  setSearchParams,
  options,
  required,
  defaultSort,
}: SortFilterProps<TFilter, E>): React.ReactElement => {
  const initialValues = useMemo(
    () => ({
      sortBy: searchParams.get("sortBy") || (defaultSort ?? "CustomerName"),
    }),
    []
  );

  const updateSortBy = (val: string | null) => {
    setFilters({ ...(filters ?? ({} as TFilter)), sortBy: val! });

    const newParams = {};
    Array.from(searchParams.entries()).forEach(([k, v]) => (newParams[k] = v));

    if (val) {
      newParams["sortBy"] = val;
    } else {
      delete newParams["sortBy"];
    }

    setSearchParams(newParams);
  };

  return (
    <div>
      <ClientForm initialValues={initialValues} onSuccess={() => undefined}>
        <EnumDropdownFormField
          label={"Sort By"}
          formField={"sortBy"}
          helperText={""}
          options={options}
          required={required}
        />
        <ValueRenderer
          render={(values) => (
            <Updater
              value={values.sortBy}
              callback={(val) => {
                if (filters && val !== filters.sortBy) {
                  updateSortBy(val);
                }
              }}
            />
          )}
        />
      </ClientForm>
    </div>
  );
};
